/**
 * Стандартный набор эмодзи делений шкалы согласия (`likert_scale`): им плеер
 * рисует шкалу, пока своих эмодзи меньше, чем делений
 * (`public-blocks/LikertScaleRenderer.tsx`), и его же показывает панель
 * (`EmojiSteps`, WEB-3767 п. 12). Отдельным модулем: доли публичного рендерера
 * импортирует только фасад хвоста (сторож WEB-2920).
 */
export const LIKERT_DEFAULT_EMOJIS: readonly string[] = ['😞', '😐', '🙂', '😊', '😄', '🤩', '🥳'];
